/** Proposal 카드 버튼 클릭. 호스트 모달과 분리해 위젯이 직접 기록한다. */

// node 단위 테스트에서도 로드되도록 확장자를 쓴다(tsconfig allowImportingTsExtensions).
import { isAdminPreview } from "../lib/adminPreview.ts";

// Vite 밖(node 단위 테스트)에서는 import.meta.env 가 없다.
const API_BASE = import.meta.env?.VITE_API_BASE || "";

const CLICK_EVENT: Record<string, string> = {
  scenario: "scenario_nudge_click",
  exit: "exit_nudge_click",
  reentry: "reentry_nudge_click",
};

/**
 * 모달 메시지 전에 호출. 실패해도 모달은 연다 — 반환 Promise 는 요청이 끝나면
 * resolve 하고 reject 하지 않는다.
 * ``resultId`` 를 보내면 서버가 이어지는 summary-email 을 이 카드의 Submit 으로 기록한다.
 * 그래서 넛지 카드는 이 Promise 를 기다린 뒤 모달을 연다 (Submit 이 클릭 기록보다 먼저 오지 않게).
 */
export function recordProposalFunnelClick(
  sessionToken: string,
  variant: string | undefined,
  scenarioTrigger?: string,
  resultId?: string,
): Promise<void> {
  const sid = String(sessionToken || "").trim();
  const event =
    CLICK_EVENT[String(variant || "scenario").trim().toLowerCase()] ||
    CLICK_EVENT.scenario;
  // Admin 미리보기 클릭은 고객 퍼널 KPI 가 아니다.
  if (!sid || isAdminPreview()) return Promise.resolve();
  const body: { event: string; scenarioTrigger?: string; resultId?: string } = { event };
  if (event === "scenario_nudge_click" && scenarioTrigger !== undefined) {
    body.scenarioTrigger = String(scenarioTrigger || "").trim().toLowerCase();
  }
  const rid = String(resultId || "").trim();
  if (rid) body.resultId = rid;
  const url = `${API_BASE}/api/commerce/session/${encodeURIComponent(sid)}/proposal-funnel`;
  return fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify(body),
  }).then(
    () => undefined,
    () => undefined,
  );
}
